import { useCallback, useEffect, useState } from 'react';
import { formatCustomTime, parseCustomTime } from '../../utils/video';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomTimeInput = ({
  value,
  video,
  onChange,
  trackVideoInteraction
}) => {
  const [currentTimeDisplay, setCurrentTimeDisplay] = useState(formatCustomTime(value));
  useEffect(() => {
    setCurrentTimeDisplay(formatCustomTime(value));
  }, [value]);
  const handleBlur = useCallback(e => {
    trackVideoInteraction('change-overlay-delay-via-input');
    const parsedValue = parseCustomTime(e.target.value);
    if (typeof parsedValue === 'number' && parsedValue >= 0 && parsedValue <= Math.floor(video.duration / 1000)) {
      onChange(parsedValue);
    } else {
      setCurrentTimeDisplay(formatCustomTime(value));
    }
  }, [value, onChange, trackVideoInteraction, video.duration]);
  const handleChange = useCallback(e => {
    setCurrentTimeDisplay(e.target.value);
  }, []);
  return /*#__PURE__*/_jsx(TextInput, {
    value: currentTimeDisplay,
    onBlur: handleBlur,
    onChange: handleChange,
    "data-test-id": "conv-asset-panel-delay-seconds"
  });
};
export default CustomTimeInput;